import React from "react";
import moment from "moment";
import { Trans, useTranslation } from "react-i18next";
import * as SC from "./StatusWindow.styled";

import { bannerSettings } from "../../../../PagesUser/SelfServiceCampaignCreation/Previews/constants";

const StatusWindow = ({ status = "", startDate }) => {
  const { t } = useTranslation();
  const {
    icon = "/images/create_post_info_icon.svg",
    mainText_locale = { en: "Automatically generated display" },
    extraText_locale = {
      en: "We automatically extract data from your job advertisement. Of course, you can still customize the advertisement."
    }
  } = bannerSettings[status] || {};

  const localizedMainText = mainText_locale.en;
  const localizedExtraText = extraText_locale.en;

  let campaignWillGoLiveSoon = false;
  // If the campaign was planned to go live before but the status is still not live, then add
  // a message that the campaign will be set live automatically with in the next hour
  if (status == "SCHEDULED" && startDate && moment(startDate) < moment()) {
    campaignWillGoLiveSoon = true;
  }

  return (
    <SC.StatusWindowWrapper>
      <SC.StatusTitle>Status</SC.StatusTitle>
      <SC.StatusBox key={status} status={status}>
        <SC.StatusHeaderSection>
          <SC.StatusHeaderIcon>
            <img src={icon} />
          </SC.StatusHeaderIcon>
          <SC.StatusHeaderTitle>
            <Trans>{localizedMainText}</Trans>
          </SC.StatusHeaderTitle>
        </SC.StatusHeaderSection>
        <SC.StatusBody>
          <Trans>{localizedExtraText}</Trans>{" "}
          {campaignWillGoLiveSoon
            ? t("This campaign will automatically go live in the next hour.")
            : ""}
        </SC.StatusBody>
      </SC.StatusBox>
    </SC.StatusWindowWrapper>
  );
};

export default StatusWindow;
